import React from 'react';
import PropTypes from 'prop-types';
import BarChartWithThreshold from './BarChartWithThreshold';
import { chartTheme } from './chartTheme';

const BarChartSectionAverages = ({ data }) => {
  return (
    <BarChartWithThreshold
      data={data}
      title="Course Average by Section"
      description={`
        This chart displays the <b style="color:${chartTheme.main}">overall course average</b> by section.
        Only sections under the requested <b style="color:red;">${data.numericPercentage}%</b> average are represented.
        The <b style="color:red;">dotted line</b> indicates that threshold.
      `}
      threshold={data.numericPercentage}
      series={[
        {
          dataKey: 'averagePercentage',
          name: 'Average Percentage',
          color: chartTheme.secondary,
          stackId: 'a',
        },
      ]}
    />
  );
};

export default BarChartSectionAverages;

BarChartSectionAverages.propTypes = {
  data: PropTypes.shape({
    sections: PropTypes.array,
    numericPercentage: PropTypes.number,
  }).isRequired,
};
